import { useMutation, useQueryClient } from '@tanstack/react-query';
import { riskCalculationApi } from '@/services/riskCalculationApi';
import { BaseRiskCalculation } from '@/dtos/RiskCalculations/index';
import { RecommendationCalculation } from '@/dtos/ResultCalculations/index';
import { toast } from 'sonner';

export function useUpdateRecommendations() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, recommendations }: { id: string; recommendations: RecommendationCalculation[] }) =>
      riskCalculationApi.updateRecommendations(id, recommendations),
    onSuccess: (response) => {
      if (response.isSuccess && response.data) {
        toast.success('Recomandările au fost actualizate cu succes');
        // Invalidate relevant queries to refetch updated data
        queryClient.invalidateQueries({ queryKey: ['risk-calculations'] });
        queryClient.invalidateQueries({ queryKey: ['flow-clinical-sessions'] });
        // Return the updated data so it can be used in the component
        return response.data;
      } else {
        toast.error(response.errorMessage || 'Eroare la actualizarea recomandărilor');
      }
    },
    onError: (error) => {
      toast.error('Eroare la actualizarea recomandărilor');
      console.error('Failed to update recommendations:', error);
    },
  });
}
